const EventType = {
  CLICKED: 'clicked',
  CLICKED_FEATURED_POST: 'clicked-featured-post',
  CLICKED_NEWSFEED_ITEM: 'clicked-newsfeed-item',
  CLICKED_NEXT_POST: 'clicked-next-post',
  CLICKED_RELATED_POST: 'clicked-related-post',
  DISMISSED_FEATURED_POST: 'dismissed-featured-post',
  FOLLOWED_USER: 'followed-user',
  SEARCHED_COMMUNITY: 'searched-community',
  SEARCHED_SITE: 'searched-site',
  SIGNED_UP: 'signed-up',
  SKIPPED_FEATURED_POST: 'skipped-featured-post',
  VIEWED_COMMUNITY: 'viewed-community',
  VIEWED_FEATURED_POST: 'viewed-featured-post',
  VIEWED_FEATURED_POST_UNIQUE: 'viewed-featured-post-unique',
  VIEWED_NEWSFEED: 'viewed-newsfeed',
  VIEWED_PAGE: 'viewed-page',
  VIEWED_POST: 'viewed-post',
  VIEWED_USER: 'viewed-user',
  VIEWED_RETENTION_FEED: 'viewed-retention-feed',
  CLICKED_RETENTION_FEED_ITEM: 'clicked-retention-feed-item',
  PROFILE_SURVEY: 'profile-survey',
  NEEDS_ASSESSMENT: 'needs-assessment',
  CHANGED_BROWSER_NOTIFICATIONS: 'changed-browser-notifications',
  CLICKED_REMOVE_REVIEW_TAG: 'clicked-remove-review-tag',
};

export default EventType;

export const ANONYMOUS_EVENTS = [
  EventType.CLICKED,
  EventType.VIEWED_PAGE,
];



// WEBPACK FOOTER //
// ./app/assets/js/config/footfallEventTypes.js